const formatOpenJobs = (jobs) => {
  const currentDate = new Date().getTime();
  return jobs.map((job) => {
    const timeDifferenceInMillis = Math.abs(currentDate - job.postingDate);
    const timeDifferenceInDays = Math.floor(
      timeDifferenceInMillis / (1000 * 60 * 60 * 24)
    );
    return {
      ...job,
      daysOpen: timeDifferenceInDays,
    };
  });
};

export default formatOpenJobs;
